/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/Footer/SubmitAction",
  isSubmitting
  
}) {
let tabSchedulingValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'scheduling',
})
let appointmentOverlayValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
})
let aggregateData = fromHelpers.isDisabled(tabSchedulingValueData, appointmentOverlayValueData)
let appointmentOverlayIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'appointment_overlay',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
let appointmentOverlayAppointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'appointment_id',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 disabled={aggregateData ? true : appointmentOverlayIsSubmittingData ? true : false}
 onClick={onClick}
 data={aggregateData ? "appointment_overlay" : "tab.scheduling"}
 data={aggregateData ? "appointment_overlay" : "appointment_overlay"}
 aggregate="helpers.js isDisabled"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={appointmentOverlayAppointmentIdValueData ? "Save changes" : "Schedule appointment"}
 data="appointment_overlay.appointment_id"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}